<app-feature-hero
  title="Service Desk as MSP solution"
  description="Our ITIL-aligned Service Desk as the first line of support for all MSPs"
  image=""
  imageAlt=""
></app-feature-hero>

<app-feature-row
  headingLevel="h2"
  heading="What is a Service Desk for MSP?"
  [paragraphs]="whatIsParagraphs"
  image="/assets/img/feature-pages/infraon-assets/msp-solution/Group2131.png"
  imageAlt="hardware asset management"
  imagePosition="right"
></app-feature-row>

<app-feature-row
  headingLevel="h2"
  heading="What does a Service Desk do?"
  [paragraphs]="whatDoesItDoParagraphs"
  image="/assets/img/feature-pages/infraon-assets/msp-solution/msp-feaature-2.png"
  imageAlt="hardware asset management"
  imagePosition="left"
></app-feature-row>

<section class="bg-grey section-spacing key-benifit">
  <div class="container">
    <div class="row mx-0">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <h2 class="section-title pb-4">
          Key benefits of a<br />
          Service Desk for MSP
        </h2>
        <a
          class="primary-buttons cta-buttons rounded-l"
          [routerLink]="['/registration']"
          [queryParams]="{ type: 'trial' }"
          >Start Your Free Trial</a
        >
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-assets/msp-solution/new-user.svg"
              alt="User Icon 2"
            />
            <p class="section-title-s text-start py-3">Track and manage customer inquiries</p>
            <p class="section-paragraph-s text-start">
              The centralized Service Desk solution for MSP can help view all tickets in one place,
              quickly identify and assign tickets to the appropriate representative, and track the
              progress of each ticket. This helps ensure that all tickets are resolved on time and
              that no tickets are forgotten or left unresolved.
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-assets/msp-solution/clock-small.svg"
              alt="Clock icon"
            />
            <p class="section-title-s text-start py-3">Improve operations with automation</p>
            <p class="section-paragraph-s text-start">
              Automating routine tasks can ensure zero downtime and save time and resources. MSPs
              can also improve overall operations and enable a seamless customer experience with a
              unified Service Desk platform to resolve tickets quickly through multiple channels,
              such as Email to Ticket, AI-driven chatbots, and more.
            </p>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-assets/msp-solution/headphones-new-feature.svg"
              alt="Headphones icon 2"
            />
            <p class="section-title-s text-start py-3">Proactive support for zero downtime</p>
            <p class="section-paragraph-s text-start">
              Infraon's Service Desk enables increased efficiency from a unified dashboard. It helps
              proactively identify and resolve potential problems before they cause disruptions or
              downtime for customers. The automated workflows enable assigning appropriate agents
              and resolving tickets in real time. You can also track and manage agent performance to
              ensure proactive support and enhance customer experience.
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-assets/msp-solution/user-check-small.svg"
              alt="user checklist icon"
            />
            <p class="section-title-s text-start py-3">Personalized customer support</p>
            <p class="section-paragraph-s text-start">
              Use predictive analytics to help improve customer satisfaction and increase customer
              loyalty. MSPs can offer customized support to individual client needs instead of a
              generic solution. Analytics and detailed reports can ensure a better understanding of
              the history and pattern of client needs and decrease ticket resolution time. Generate
              detailed data-driven reports and get insights to improve decision-making.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center p-b-60">Using Infraon's Service Desk for MSP</h2>

  <div class="row mx-0 justify-content-evenly">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/user-small.svg"
          alt="User icon small"
        />
      </div>
      <p class="section-title-s">Customer insights and analytics</p>
      <p class="section-paragraph-s">
        Infraon's ITIL-aligned Service Desk provides analytics and support to troubleshoot and
        resolve customer issues. MSPs can quickly identify problems causing disruption and resolve
        them in real time. They can use data analytics to track and analyze customer data to improve
        their customer support strategy and enhance customer experience.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/command-small.svg"
          alt="Mcbook command icon"
        />
      </div>
      <p class="section-title-s">Pre-built AI-driven workflows</p>
      <p class="section-paragraph-s">
        MSPs can use pre-built AI-driven workflows with ML to automate resolving common issues and
        requests. Infraon's Service Desk software gives access to historical data and helps identify
        patterns to provide faster and more accurate resolutions. It can ensure reduced workload for
        support staff and improve the overall efficiency of the help desk.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/config.svg"
          alt="Config Icon"
        />
      </div>
      <p class="section-title-s">Integrated IT management</p>
      <p class="section-paragraph-s">
        Infraon's Service Desk can enable MSPs to transform client business services with increased
        productivity and maximum efficiency. The extensive API support and integration feature help
        provide a centralized location for all support requests. The ITSM-enabled features help
        track and manage inquiries in one place, assign appropriate representatives, and provide a
        single point of contact.
      </p>
    </div>
  </div>

  <div class="row mx-0 justify-content-evenly">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/cell-phones-small.svg"
          alt="Cell phone icon"
        />
      </div>
      <p class="section-title-s">Service asset management</p>
      <p class="section-paragraph-s">
        Infraon's Service Desk provides complete visibility of assets, infrastructure, and their
        relationships with the CMDB. The quick scan and search feature helps find assets in trouble
        and also helps manage SLAs through Barcode and QR code tracking to improve system
        availability and performance. Service Desk ensures all assets meet maximum SLA and are
        audit-ready at any time.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/grid.svg"
          alt="Grid icon"
        />
      </div>
      <p class="section-title-s">Unified dashboard and reporting</p>
      <p class="section-paragraph-s">
        Infraon's Service Desk offers a configurable dashboard with real-time alerts based on
        escalation and role-based access. It also offers an array of data analytics for all
        incidents and reports on incident, problem and change management for improved performance
        and better decision-making.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/msp-solution/smiley-01.svg"
          alt="Smiley Icon"
        />
      </div>
      <p class="section-title-s">Self-service and user-friendly UI</p>
      <p class="section-paragraph-s">
        The user-friendly and intuitive interface in Infraon's Service Desk is designed for ease of
        use and navigation. The self-service portal enables self-help with the knowledge base and
        resources for a quick resolution. MSP clients can get the help they need without needing
        external support.
      </p>
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div id="gdpr-wrapper">
    <div class="gdpr-section justify-content-center">
      <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100" />
      <div>
        <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
        <p class="section-paragraph mb-0">
          We are compliant with the European General Data Protection Regulation (GDPR) – and <br />
          our SaaS-based product suite is fully committed to protecting the data of our customers
          <br />
          as per the recent standards.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="section-spacing primary-bg trial-now">
  <div class="container">
    <h2 class="section-title text-center text-white">
      <span class="text-lowercase">How about a free trial with NO credit card required?</span>
    </h2>

    <div class="d-flex justify-content-center">
      <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white"
        >Start now</a
      >
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center">Related Content</h2>

  <div class="row mx-0">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/it-assets-management-solutions">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong>IT asset management</strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
            optimize your IT asset usage. Make smart purchasing...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/software-assets-management-solutions">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong>Software asset management</strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
            optimize your IT asset usage. Make smart purchasing...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/software-license-management">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong>Software Licensing management</strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon Assets helps you manage the lifecycles of fixed assets like PCs, laptops,
            furniture, storage devices, etc., with a 360-degree view...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
  </div>
</section>

<section class="section-spacing bg-grey">
  <div class="container" id="g2-box-wrapper">
    <div class="g2-box justify-content-between">
      <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo" />
      <p>
        Already love using our products? Please <br />
        share your experiences on G2
      </p>
      <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button"
        >Rate us</a
      >
    </div>
  </div>
</section>
